import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {CancelButton, SubmitButton, TextInputStyled, Title} from './VoucherModal.style';
import {FormattedMessage} from 'react-intl';
import {Wrapper, StatusImage, Status} from '../Modal/modal.style';
import success from '../../assets/images/success.png';
import failed from '../../assets/images/fail.png';
import {getVoucherInPromotion, compareVoucherDiff} from '../../helpers/checkoutPage.helper';

export class VoucherModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitted: false,
      showStatus: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.initialVoucher = props.vouchers;
  }

   componentWillReceiveProps(nextProps) {
    const {vouchers} = nextProps;
    if (vouchers && (
      (this.initialVoucher && compareVoucherDiff(vouchers, this.initialVoucher)) || this.initialVoucher.length === 0
    )) {
      this.setState({showStatus: true});
    }
  }

  handleSubmit() {
    const {submitVoucher, voucherValue} = this.props;
    if (!voucherValue) {
      return;
    }
    this.setState({isSubmitted: true});
    submitVoucher();
  }
  render() {
    const {voucherChange, closeModalCallback, vouchers, voucherMessage} = this.props;
    const appliedVoucher = getVoucherInPromotion(vouchers);
    const renderButtonText = this.state.isSubmitted ? 'checkout.voucherModalTryAgain' : 'checkout.voucherModalSubmitButton';
    const renderCloseOrCancel = appliedVoucher && appliedVoucher.applied ? 'checkout.voucherModalCloseButton' : 'checkout.voucherModalCancelButton';
    const renderSymbol = this.state.isSubmitted && this.state.showStatus && appliedVoucher && (
      <Status>
        <StatusImage src={appliedVoucher.applied ? success : failed} />
        {voucherMessage}
      </Status>
    );
    const renderSubmit = (!this.state.isSubmitted || (appliedVoucher && !appliedVoucher.applied)) && (
      <SubmitButton onClick={this.handleSubmit}>
        <FormattedMessage id={renderButtonText} />
      </SubmitButton>
    );
    return (
      <Wrapper>
        <Title><FormattedMessage id="checkout.voucherModalTitle" /></Title>
        {renderSymbol}
        <TextInputStyled
          type="text"
          onChange={voucherChange}
        />
        {renderSubmit}
        <CancelButton onClick={closeModalCallback}>
          <FormattedMessage id={renderCloseOrCancel} />
        </CancelButton>
      </Wrapper>
    );
  }
}

VoucherModal.propTypes = {
  closeModalCallback: PropTypes.func,
  submitVoucher: PropTypes.func.isRequired,
  voucherChange: PropTypes.func.isRequired,
  voucherMessage: PropTypes.array,
  vouchers: PropTypes.array,
  voucherValue: PropTypes.string
};

export default VoucherModal;



// WEBPACK FOOTER //
// ./components/VoucherModal/VoucherModal.js